var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3.33333H22.5C23.163 3.33333 23.7989 3.59673 24.2678 4.06557C24.7366 4.53441 25 5.17029 25 5.83333V22.5C25 23.163 24.7366 23.7989 24.2678 24.2678C23.7989 24.7366 23.163 25 22.5 25H2.5C1.83696 25 1.20107 24.7366 0.732233 24.2678C0.263392 23.7989 0 23.163 0 22.5L0 5.83333C0 5.17029 0.263392 4.53441 0.732233 4.06557C1.20107 3.59673 1.83696 3.33333 2.5 3.33333H5V0H6.66667V3.33333H18.3333V0H20V3.33333ZM10 13.3333H5V11.6667H10V13.3333ZM20 11.6667H15V13.3333H20V11.6667ZM10 18.3333H5V16.6667H10V18.3333ZM15 18.3333H20V16.6667H15V18.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.31f749586e9fbae929dcf874554a1970.svg";
export { ForwardRef as ReactComponent };